import styled from "styled-components";

export const DailySettlementDropBox = styled.div`
  position: absolute;
  border-radius: 8px;
  gap: 4px;
  padding: 12px;
  box-shadow: 0px 0px 8px 0px #0000001f;
  box-sizing: border-box;
  top: 40px;
  right: 0;
  z-index: 1000;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 550px;
  overflow: auto;
  scrollbar-width: none;

  > .item {
    height: 30px;
    border-radius: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    border: 1px solid var(--Black-100, #f0f0f0);
    gap: 8px;
    flex-shrink: 0;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 15px;
    color: #121212;
    cursor: pointer;

    &.selected {
      background: var(--Purple-300, #6436e7);
      color: #fff;
    }
  }
`;

export const DailySettlementPopupWrapper = styled.div`
  width: 376px;
  border-radius: 13px;
  background: #ffffff;
  padding: 40px 20px 30px;
  box-sizing: border-box;
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  > .data {
    color: #bebebe;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 13px;
    margin-top: 20px;
    margin-bottom: 8px;
  }
`;

export const DailySettlementPopupContent = styled.div<{ isData: boolean }>`
  border-radius: 12px;
  padding: 20px 15px;
  background: #f0f0f0;
  box-sizing: border-box;
  margin-top: ${(p) => (p.isData ? "0" : "20px")};
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 60px;
`;
